import type { BuildHubCollaborator } from '../types';

/**
 * Gets the avatar image URL for a BuildHub collaborator with fallback logic.
 *
 * Priority order:
 * 1. Member's profile image (if uploaded)
 * 2. TeamMember's photo (if collaborator has a TeamMemberID and photo is uploaded)
 * 3. undefined (will display initials as fallback)
 *
 * @param collaborator - The BuildHub collaborator
 * @returns The avatar image URL or undefined
 */
export const getCollaboratorAvatar = (
    collaborator: BuildHubCollaborator,
): string | undefined => {
    // First priority: Member's profile image
    if (collaborator.image) {
        return collaborator.image;
    }

    // Second priority: TeamMember's photo
    if (collaborator.teamMember?.memberImage?.teamMemberDisplay) {
        return collaborator.teamMember.memberImage.teamMemberDisplay;
    }

    // Last resort: return undefined so initials will be shown
    return undefined;
};
